module.exports = __webpack_public_path__ + "static/media/padlock.1f83e67d.svg";